import React from "react";
import { Route, Routes } from "react-router-dom";
import TabNavigation from "./Container/navbar";
import HomePendingVerification from "./Container/MultiCurrencyBank/AccountVerification.jsx";
import { ProtectedRoute } from "./Utils/ProtectedRoutes";
import EmailAddress from "./Components/AccountExist/EmailAdderess";
import OTPPage from "./Components/AccountDoesNotExist/OTPPage";
import CreatePass from "./Components/AccountDoesNotExist/CreatePass";
import Registration from "./Container/Auth/SignUp";
import AccountDetected from "./Components/AccountExist/AccountDetected";
import LoginAccount from "./Container/Auth/LoginAccount";
import AccountSettings from "./Container/AccountSettings";
import LandingPage from "./Container/LandingPage";
import SelfieEmptyRoute from "./Container/SelfieEmptyRoute";
import ForgotPassword from "./Container/Auth/ForgotPassword";
import { PersistRoute } from "./Utils/PersistLogin";
import { useOverview } from "./hooks";
import HelpSupport from "./Components/ContactUS";
import PageNotFound from "./Components/PageNotFound";
import CustomSheet from "./drawer";
import SsoLogin from "./Container/Auth/SSOLogin";

const CustomRoute = ({ setIsOpenInvalidTokenModal }) => {
  const { isOpen, setIsOpen } = useOverview();
  return (
    <>
      <Routes>
        {/* exist flow */}
        <Route path="/" element={<LandingPage />} />
        <Route element={<PersistRoute />}>
          <Route path="/email" element={<EmailAddress />} />
          <Route path="/exist" element={<AccountDetected />} />
          <Route path="/login" element={<LoginAccount />} />
          <Route path="/sso-login/:token" element={<SsoLogin />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          {/* does not exist flow */}
          <Route path="/verify-otp" element={<OTPPage />} />
          <Route path="/create-user" element={<CreatePass />} />
          <Route
            element={
              <ProtectedRoute
                setIsOpenInvalidTokenModal={setIsOpenInvalidTokenModal}
              />
            }
          >
            <Route path="/details" element={<Registration />} />
            <Route path="/redirect" element={<SelfieEmptyRoute />} />
          </Route>
        </Route>

        <Route
          element={
            <ProtectedRoute
              setIsOpenInvalidTokenModal={setIsOpenInvalidTokenModal}
            />
          }
        >
          <Route path="/home" element={<TabNavigation />} />
          <Route
            path="/homeVerification"
            element={<HomePendingVerification />}
          />
          <Route path="/account" element={<AccountSettings />} />
        </Route>
        <Route path="/contact" element={<HelpSupport />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      {/* drawer components */}
      <CustomSheet isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default CustomRoute;
